"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.links = void 0;
var _fetching = require("@ori/fetching");
const links = exports.links = (0, _fetching.gql)`
  fragment SearchPreviewLink on Link {
    title
    relativeUrl
  }
`;
